import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils/classnames.js';
function Background({ className, children, style }) {
    return (_jsxs("div", { className: cn('ui-relative ui-isolate ui-size-full', className), style: style, children: [_jsx("div", { className: "ui-absolute ui-inset-0 ui-z-[-1] ui-bg-brand-gradient theme-dark:ui-bg-dark-gradient" }), children] }));
}
export default Background;
